define('RunOnEveryPage/components/formValidationErrorHandling',[],

    function () {

        function init() {          
            $(document).ready(function () {  
                //handling required and validation error
                //don't show both errors (just validation error)
                formErrorHandling();
                //after submiting form, all events are lost and bind them again
                $(document).ajaxComplete(function () {
                    formErrorHandling();
                });
            });           
        }

        function formErrorHandling() {
            $(".form-error-handling").on('keyup', function () {               
                var inputElement = $(this).parent();
                var validationMessageElement = inputElement.find(".field-validation-message");
                if (validationMessageElement && validationMessageElement.length) {
                    if (this.value.length == 0)
                        validationMessageElement.show();
                    else
                        validationMessageElement.hide();
                }
            });    
        }

        return {
            init: init
        };
    }
);
